import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { Typography } from '@material-ui/core';
import QuestionHeader from './QuestionHeader';
import FormFilesUploadField from '../form/FormFilesUploadField';
import numberAsText from '../../utils/numberAsText';

const SubmissionFilesUpload = ({ name, number, questionText, readonly, isOptional, fileSizeLimitMegabytes, filesCountLimit, surveyId, questionId, acceptedMimeTypes, onDeleteUploadedFile }) => (
  <div className="box">
    <div className="col-sm-12">
      <QuestionHeader name={questionText} number={number} />
      {isOptional && <Typography variant="caption" color="textSecondary" display="block">Dołączenie plików nie jest wymagane</Typography>}
      <Typography variant="caption" color="textSecondary" display="block">
        {`Można załączyć maksymalnie ${numberAsText(filesCountLimit, ['plików', 'plik', 'pliki'])}, każdy o rozmiarze nieprzekraczającym ${fileSizeLimitMegabytes} MB`}
      </Typography>
      <div>
        <Field
          name={`${name}.files`}
          component={FormFilesUploadField}
          disabled={readonly}
          surveyId={surveyId}
          questionId={questionId}
          fileSizeLimitMegabytes={fileSizeLimitMegabytes}
          filesCountLimit={filesCountLimit}
          acceptedMimeTypes={acceptedMimeTypes}
          onDeleteUploadedFile={onDeleteUploadedFile}
        />
      </div>
    </div>
  </div >
);

SubmissionFilesUpload.propTypes = {
  name: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  questionText: PropTypes.string.isRequired,
  readonly: PropTypes.bool,
  isOptional: PropTypes.bool,
  surveyId: PropTypes.string.isRequired,
  questionId: PropTypes.string.isRequired,
  fileSizeLimitMegabytes: PropTypes.number.isRequired,
  filesCountLimit: PropTypes.number.isRequired,
  acceptedMimeTypes: PropTypes.string,
  onDeleteUploadedFile: PropTypes.func.isRequired,
};

export default SubmissionFilesUpload;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/SubmissionFilesUpload.js